import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { readSecurityModeStored, useSecurityModeStored, writeSecurityModeStored } from './securityModeStore';

interface ComponentProps {
  smallMenu?: boolean;
}

const SecurityModeMenuSwitch: React.FC<ComponentProps> = ({ smallMenu }) => {
  const enabled = useSecurityModeStored();

  const toggle = () => writeSecurityModeStored(readSecurityModeStored() !== '1');

  // Same icon column as MenuItem — pl-7 in the rail and pl-4 expanded, both around a w-6 box —
  // so the shield lines up with the menu icons above it instead of drifting on its own padding.
  const shield = (
    <span className={`shrink-0 flex items-center justify-center w-6 ${enabled ? 'text-[var(--ringil3-brand-color,#FE5000)]' : 'text-gray-400'}`}>🛡</span>
  );

  if (smallMenu) {
    return (
      <div className="flex items-center pl-7 pr-4 py-2 cursor-pointer" onClick={toggle} title="Security mode">
        {shield}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between pl-4 pr-4 py-2">
      <span className="flex items-center gap-4 text-sm">
        {shield}
        Security mode
      </span>
      <InputSwitch checked={enabled} onChange={toggle} />
    </div>
  );
};

export default SecurityModeMenuSwitch;